export const CREATE_DESIGN_START = 'CREATE_DESIGN_START';
export const CREATE_DESIGN_SUCCESS = 'CREATE_DESIGN_SUCCESS';
export const CREATE_DESIGN_FAILED = 'CREATE_DESIGN_FAILED';

export const CREATE_ITEM_START = 'CREATE_ITEM_START';
export const CREATE_ITEM_SUCCESS = 'CREATE_ITEM_SUCCESS';
export const CREATE_ITEM_DETAILS_SUCCESS = 'CREATE_ITEM_DETAILS_SUCCESS';
export const CREATE_ITEM_FAILED = 'CREATE_ITEM_FAILED';

export const REMOVE_ITEM_FROM_DESIGN_START = 'REMOVE_ITEM_FROM_DESIGN_START';
export const REMOVE_ITEM_FROM_DESIGN_SUCCESS = 'REMOVE_ITEM_FROM_DESIGN_SUCCESS';
export const REMOVE_ITEM_FROM_DESIGN_FAILED = 'REMOVE_ITEM_FROM_DESIGN_FAILED';

export const CREATE_ITEM_PRODUCT_START = 'CREATE_ITEM_PRODUCT_START';
export const CREATE_ITEM_PRODUCT_SUCCESS = 'CREATE_ITEM_PRODUCT_SUCCESS';
export const CREATE_ITEM_PRODUCT_FAILED = 'CREATE_ITEM_PRODUCT_FAILED';

export const CREATE_CONFIG_START = 'CREATE_CONFIG_START';
export const CREATE_CONFIG_PAUSED = 'CREATE_CONFIG_PAUSED';
export const CREATE_CONFIG_SUCCESS = 'CREATE_CONFIG_SUCCESS';
export const CREATE_CONFIG_FAILED = 'CREATE_CONFIG_FAILED';

export const CREATE_CONTAINER_SUCCESS = 'CREATE_CONTAINER_SUCCESS';
export const ALL_DONE = 'ALL_DONE';
export const IS_FAILED = 'IS_FAILED';
export const VIEW_ACCESSORIES = 'VIEW_ACCESSORIES';

export const UPDATE_LOGO_COLOR_COUNT = 'UPDATE_LOGO_COLOR_COUNT';
export const SAVE_UPDATED_LOGO_COLOR_COUNT = 'SAVE_UPDATED_LOGO_COLOR_COUNT';

export const IS_ATC_START = 'IS_ATC_START';